export const THEMES: Record<string, Partial<Record<string, string>>> = {
  grupo8: {
    '--color-primary-10': '#fdf1eb',
    '--color-primary-50': '#0BA5EC',
    '--color-primary-75': '#f9c5b3',
    '--color-primary-100': '#f9c5b3',
    '--color-primary-200': '#ec4641',
    '--color-primary-300': '#62B1F2',
    '--color-primary-400': '#ec4641',
    '--color-primary-500': '#ec4641',
    '--color-primary-600': '#ec4641',
    '--color-primary-700': '#b7221e',
    '--color-primary-800': '#0359A0',
    '--color-primary-900': '#004A87',
    '--color-primary-1000': '#00175d',

    '--color-background-25': '#FCFCFD',
    '--color-background-75': '#6981f5',
    '--color-background-90': '#fdf1eb',
    '--color-background-50': '#EBF6FF',
    '--color-background-100': '#f9c5b3',
    '--color-background-200': '#FEF9F9',
    '--color-background-300': '#FEF9F9',
  },
  default: {
    '--color-primary-10': '#EAF2FF',
    '--color-primary-50': '#0BA5EC',
    '--color-primary-75': '#CDE9FE',
    '--color-primary-100': '#EBF6FF',
    '--color-primary-200': '#8DC8F9',
    '--color-primary-300': '#62B1F2',
    '--color-primary-400': '#409DE9',
    '--color-primary-500': '#268BDD',
    '--color-primary-600': '#157ACD',
    '--color-primary-700': '#0969B8',
    '--color-primary-800': '#0359A0',
    '--color-primary-900': '#004A87',
    '--color-primary-1000': '#052C42',

    '--color-background-25': '#FCFCFD',
    '--color-background-75': '#ebf6ff',
    '--color-background-90': '#ebf6ff',
    '--color-background-50': '#EBF6FF',
    '--color-background-100': '#CDE9FE',
    '--color-background-200': '#F5FAFF',
    '--color-background-300': '#F9FAFE',
  },
};
